<template>
    <div ref="abtest" :class="rootClass" class="abtest">
        <!-- 子项 -->
        <inner-children-renderer v-if="currentActive" :children="currentActive"></inner-children-renderer>
    </div>
</template>
<script>
import ChildItem from '../children/item/render.vue';
import { CHILD } from '../constant';
import request from '../assets/scripts/request';
// dedog 日志
function log(message, logLevel) {
    window['dedog'] &&
        window['dedog'].log({
            level: logLevel || 'info',
            message: JSON.stringify(message)
        });
}

const {
    plugins: { ComplexComp },
    common: {
        env: { isPreRender }
    }
} = require('@futuweb/fego-render');

export default {
    name: 'ABTest',
    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],
    props: {
        // 实验 ID
        eid: {
            type: String
        }
    },
    data() {
        return {
            current: null,
            loading: true
        };
    },
    computed: {
        currentActive() {
            return this.loading ? false : this.current;
        }
    },
    created() {
        // 预渲染情况下，不走后续流程调用接口
        if (isPreRender) {
            return;
        }
        this.initStatus();
    },
    methods: {
        async initStatus() {
            // 获取请求方法
            try {
                // version 实验组，params 内容参数
                log(`[fego abt组件请求]开始调用, 实验id: ${this.eid}`);

                const commonApiRequest = request.bindCommonApi('abtest-container');
                // 无实验ID不请求
                const res = this.eid ? await commonApiRequest.post('join', { eid: this.eid }, { group: null }) : {};
                const { version } = res;
                this.loading = false;
                // 根据 data.version 判断展示哪个 template
                const current = this.tpl.children.find((child) => child.props.version === version);
                // 判断是否 undefined
                if (!current) {
                    this.current = this.tpl.children[0];
                    return;
                }

                this.current = current;

                log(`[fego abt组件请求]调用成功, 实验结果: ${JSON.stringify(res)}`);
            } catch (error) {
                console.log(error.message);
                log(`[fego abt组件请求]调用失败, 错误信息: ${error.message}`, error);
                this.loading = false;
                this.current = this.tpl.children[0];
            }
        },
        // 模板替换
        /**
         * text: '文案'
         * params: '替换参数对象'
         */
        replaceVariable(text, params) {
            if (typeof text !== 'string') {
                return text;
            }
            const reg = /\$\{([a-zA-Z_$][a-zA-Z_$0-9]*)\}/; // ${name}
            while (reg.exec(text)) {
                text = text.replace(reg, params[RegExp.$1] || '');
            }
            return text;
        }
    }
};
</script>
<style lang="less">
@import './common.less';
.abtest {
    height: auto !important;
}
</style>
